/**
 *  get url component by creating a new anchor element and using that to parse out the url
 *  {String} url - url to prase
 *  {String} prop - get that part of the url (host/href, protocol, pathname, hash, origin)
 *  @returns the component asked for
 */
const getUrlComponent = ( url, prop ) => {
    var a = document.createElement( "a" );
    a.setAttribute( "href", url );
    return a[prop];
};

/*
 *  create a location object containing location settings from adiData or default to window.location as a compatability layer
 *  *note the catch (e) syntax is needed to deal with eslint not being able to parse catch blocks without it
 *  @returns (Object) - tier, tierSuffix (-uat), environment, tld (abc.com), affiliate
 */

const locationDetails = ( () => {
    const splitHost =
    window.location.host.split( "." ).length > 1 ?
        window.location.host.split( "." ).reverse()[2] :
        window.location.host.split( "." )[0];
    const loc =
    window.adiData && window.adiData.entryUrl ?
        {
            host: getUrlComponent( window.adiData.entryUrl, "host" ),
            href: getUrlComponent( window.adiData.entryUrl, "href" ),
            protocol: getUrlComponent( window.adiData.entryUrl, "protocol" ),
            pathname: getUrlComponent( window.adiData.entryUrl, "pathname" ),
            tier: window.adiData.environment === "uat" ? "dev" : "prod",
            //tierSuffix: window.adiData.environment === "uat" ? "-uat" : "",
            origin: getUrlComponent( window.adiData.entryUrl, "origin" ),
            hash: getUrlComponent( window.adiData.entryUrl, "hash" ),
            environment: window.adiData.environment,
        } :
        Object.assign(
            {
                tier: splitHost.match( /-uat|-dev|-stage|^localhost:\d+?$/ ) ?
                    "dev" :
                    "prod",
                environment: ( () => {
                    const tier = splitHost.match( /uat|dev|localhost/ );
                    switch ( tier ? tier[0] : "" ) {
                        case "uat":
                            return "uat";
                        case "localhost":
                        case "dev":
                            return "dev";
                        default:
                            return "prod";
                    }
                } )(),
            },
            window.location
        );
    // HSSN-4344: Default to advance.net on any non-ADI domain, simply so script can execute
    try {
        loc.tld = loc.host.match( /\.(.*)/ )[1];
    } catch ( e ) {
        loc.tld = "advance.net";
    }

    //window.adiData is not reliable.  We don't have a dev tier; always default to uat.
    loc.tierSuffix = splitHost.match( /-dev|-stage|^localhost$|-uat/ ) ? '-uat' : '';

    loc.uri = `${loc.protocol}//${loc.host}${loc.pathname}`;

    //match one of the advancelocal hosts or
    // everything inbetween . to . (www.blah.com) => blah
    if ( window.location.hostname.match( /localhost|advancelocal/ ) ) {
        loc.affiliate = document.body.getAttribute( 'data-affiliate' );
    } else {
        loc.affiliate = loc.host.match( /\.([^\.]*)/ )[1];
    }

    return loc;
} )();

export {locationDetails};
